<template>
    <div :class="dayClass">
        {{ date.day }}
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
    datesToCourses: Map<
        string,
        {
            capacityFull: boolean
            bookingPeriodUnavailable: boolean
            bookingStatus: 'open' | 'waitlist' | 'closed'
        }
    >
    date: {
        year: number
        month: number
        day: number
    }
}>()

const dateString = computed(() => {
    return (
        String(props.date.year).padStart(4, '0') +
        '-' +
        String(props.date.month + 1).padStart(2, '0') +
        '-' +
        String(props.date.day).padStart(2, '0')
    )
})

const courseInfo = computed(() => {
    return props.datesToCourses.get(dateString.value)
})

const dayClass = computed(() => {
    if (courseInfo.value === undefined) {
        return ''
    } else if (courseInfo.value.bookingStatus === 'waitlist') {
        return 'before:bg-warning-500 flex h-full w-full items-center justify-center before:absolute before:bottom-1 before:left-1.5 before:right-1.5 before:block before:h-1'
    } else if (courseInfo.value.capacityFull) {
        return 'before:bg-danger-500 flex h-full w-full items-center justify-center before:absolute before:bottom-1 before:left-1.5 before:right-1.5 before:block before:h-1'
    } else if (courseInfo.value.bookingStatus === 'closed') {
        return 'before:bg-danger-300 flex h-full w-full items-center justify-center before:absolute before:bottom-1 before:left-1.5 before:right-1.5 before:block before:h-1'
    } else if (courseInfo.value.bookingPeriodUnavailable) {
        return 'before:bg-gray-300 flex h-full w-full items-center justify-center before:absolute before:bottom-1 before:left-1.5 before:right-1.5 before:block before:h-1'
    } else {
        return 'before:bg-primary-500 flex h-full w-full items-center justify-center before:absolute before:bottom-1 before:left-1.5 before:right-1.5 before:block before:h-1'
    }
})
</script>
